import { Module } from 'vuex'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import { ModuleState, RootState } from './types'

const module: Module<ModuleState, RootState> = {
  actions,
  getters,
  mutations,
  state: {
    loading: false,
    gateways: {},
    myDates: [],
    processLog: {},
    processes: {},
    taskLog: {},
  },
}

export default module
